export enum AppRoutes {
  AUTH = 'auth',
  PROSPECTING = 'prospecting',
  FI = 'fi',
  PHOTO = 'photo',
  CONSULT = 'consult',
  FINANCE = 'finance',
}

export enum ExternalRoutes {
  PROSPECTING = '/prospecting/clients',
  FI = '/fi/main',
  PHOTO = '/photo/search',
  CONSULT = '/consult',
  FINANCE = '/finance',
}
